import { render } from "./CreateConversationModal.vue?vue&type=template&id=0b041168&scoped=true"
import script from "./CreateConversationModal.vue?vue&type=script&lang=js"
export * from "./CreateConversationModal.vue?vue&type=script&lang=js"

import "./CreateConversationModal.vue?vue&type=style&index=0&id=0b041168&lang=scss&scoped=true"
import "./CreateConversationModal.vue?vue&type=style&index=1&id=0b041168&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b041168"]])

export default __exports__